import React from 'react';

const AuthLayout = ({ children, ...restProps }) => (
  <main className="auth-layout" {...restProps}>
    <div>{children}</div>
  </main>
);

export default AuthLayout;
